// extracted by mini-css-extract-plugin
export default {"header":"components-Header-base__header--_6CCl"};